module.exports = __webpack_public_path__ + "assets/2fc23d44f3c7d35d247245426ffdd7ee.mp3";